import React, { useState } from 'react';
import { flattedArrayByKey } from '../../utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import { sqlComparisonOperators } from '../../utils/constants';

export const SelectTable = (props) => {
  const { dispatch, condition, columns, setChangeTableClicked } = props;
  return (
    <div className='row justify-content-center align-items-center mt-2'>
      <div className='col-md-6'>
        <select
          className='form-control'
          onChange={(e) => {
            if (typeof e.target.value !== 'string') return null;
            if (setChangeTableClicked) {
              setChangeTableClicked(false);
            }
            dispatch(
              apiAction({
                reduxField: 'condition',
                route: 'conditions/updateRangeQuery',
                conditionId: condition._id,
                rangeQuery: { table_name: e.target.value },
              })
            );
          }}
          style={{ textAlign: 'center' }}
        >
          <option value={null}>Choose Table...</option>
          {columns.map((col) => (
            <option key={col.table_name} value={col.table_name}>
              {col.table_name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

const SelectBuilder = (props) => {
  const dispatch = useDispatch();
  const { condition, query, setQuery } = props;
  const { loadingAddCondition } = useSelector((state) => state.general);

  const [changeTableClicked, setChangeTableClicked] = useState(false);
  const [conType, setConType] = useState('AND');
  const [field, setField] = useState(null);
  const [operation, setOperation] = useState(null);
  const [value, setValue] = useState(null);

  const columns = flattedArrayByKey(condition?.columns, 'table_name');
  console.log({ condition });
  if (
    !condition?.rangeQuery?.table_name ||
    !columns.map((col) => col.table_name).includes(condition?.rangeQuery?.table_name)
  ) {
    return (
      <>
        <div data-aos='fade-up' data-aos-delay='200'>
          <div className='row justify-content-center align-items-center mt-4'>
            <h5>Please choose a table to build a query.</h5>
          </div>
          <SelectTable dispatch={dispatch} condition={condition} columns={columns} />
        </div>
      </>
    );
  }
  return (
    <>
      <div data-aos='fade-up' data-aos-delay='200'>
        <div className='row justify-content-center align-items-center mt-4'>
          <h4>Selected Table </h4>
        </div>

        {changeTableClicked ? (
          <SelectTable
            dispatch={dispatch}
            condition={condition}
            columns={columns}
            setChangeTableClicked={setChangeTableClicked}
          />
        ) : (
          <div className='row justify-content-center align-items-center border-bottom mt-2'>
            <h6>
              <button
                className='btn btn-outline-dark'
                title='Click to Change Table'
                onClick={() => setChangeTableClicked(true)}
              >
                <i className='fa-solid fa-table'></i> {condition.rangeQuery.table_name}
              </button>
            </h6>
          </div>
        )}
        <div className='row justify-content-center align-items-center mt-4'>
          <h4>Columns to Fetch</h4>
        </div>
        <div className='row justify-content-center align-items-center '>
          {!condition.rangeQuery.columnsIds || condition.rangeQuery.columnsIds.length < 1 ? (
            <small className='text-danger'>Please add at least one column</small>
          ) : null}
        </div>
        <>
          <div className='row justify-content-center align-items-center border-bottom mt-2'>
            {condition.columns
              ?.filter((col) => col.table_name === condition.rangeQuery?.table_name)
              .map((col) => {
                return (
                  <button
                    key={col.column_name}
                    className={`btn btn-sm btn${
                      condition.rangeQuery?.columnsIds?.includes(col._id) ? '' : '-outline'
                    }-primary m-1`}
                    onClick={() =>
                      condition.rangeQuery?.columnsIds?.includes(col._id)
                        ? dispatch(
                            apiAction({
                              reduxField: 'condition',
                              route: 'conditions/updateRangeQuery',
                              conditionId: condition._id,
                              rangeQuery: {
                                ...condition.rangeQuery,
                                columnsIds: condition.rangeQuery?.columnsIds?.filter((flt) => flt !== col._id),
                              },
                            })
                          )
                        : dispatch(
                            apiAction({
                              reduxField: 'condition',
                              route: 'conditions/updateRangeQuery',
                              conditionId: condition._id,
                              rangeQuery: {
                                ...condition.rangeQuery,
                                columnsIds: Array.isArray(condition.rangeQuery?.columnsIds)
                                  ? [...condition.rangeQuery.columnsIds, col._id]
                                  : [col._id],
                              },
                            })
                          )
                    }
                  >
                    {col.column_name}
                  </button>
                );
              })}
          </div>
        </>
        <div className='row justify-content-center align-items-center mt-4'>
          <h4>Conditions</h4>
        </div>
        {condition.rangeQuery?.conditions?.length < 1 ? (
          <div className='row justify-content-center align-items-center mb-2'>
            <small className='text-danger'>Please add at least one condition</small>
          </div>
        ) : null}
        <div className='row justify-content-center align-items-center p-2'>
          <div className='col-md-1 d-flex justify-content-center align-items-center p-2'>
            <select
              className='form-control'
              style={{ textAlign: 'center' }}
              onChange={(e) => setConType(e.target.value)}
            >
              <option value={null}>Type</option>
              <option value='AND'>AND</option>
              <option value='OR'>OR</option>
            </select>
          </div>
          <div className='col-md-4 d-flex justify-content-center align-items-center p-2'>
            <select className='form-control' style={{ textAlign: 'center' }} onChange={(e) => setField(e.target.value)}>
              <option value={null}>Column Name</option>
              {columns
                .filter((col) => col.table_name === condition.rangeQuery?.table_name)[0]
                ?.items?.map((col) => {
                  return (
                    <option key={col._id} value={col._id}>
                      {col.column_name}
                    </option>
                  );
                })}
            </select>
          </div>

          <div className='col-md-2 d-flex justify-content-center align-items-center p-2'>
            <select
              className='form-control'
              style={{ textAlign: 'center' }}
              onChange={(e) => setOperation(e.target.value)}
            >
              <option value={null}>Operation</option>
              {sqlComparisonOperators.map((operator) => {
                return (
                  <option key={operator} value={operator}>
                    {operator}
                  </option>
                );
              })}
            </select>
          </div>
          <div className='col-md-4 d-flex justify-content-center align-items-center p-2'>
            <input
              type='text'
              className='form-control'
              placeholder='Value...'
              style={{ textAlign: 'center' }}
              onChange={(e) => setValue(e.target.value)}
            />
          </div>
          <div className='col-md-1 d-flex justify-content-center align-items-center p-2'>
            <button
              className='btn btn-outline-dark'
              disabled={loadingAddCondition}
              onClick={() => {
                if (!conType || !field || !operation || !value) return null;
                dispatch(generalSet({ reduxField: 'loadingAddCondition', value: true }));
                dispatch(
                  apiAction({
                    reduxField: 'condition',
                    route: 'conditions/updateRangeQuery',
                    conditionId: condition._id,
                    rangeQuery: {
                      ...condition.rangeQuery,
                      conditions: Array.isArray(condition.rangeQuery.conditions)
                        ? [
                            ...condition.rangeQuery.conditions,
                            {
                              conType,
                              field,
                              operation,
                              value,
                            },
                          ]
                        : [
                            {
                              column_name: field,
                              operator: operation,
                              value,
                            },
                          ],
                    },
                    setLoading: 'loadingAddCondition',
                  })
                );
              }}
            >
              Add
            </button>
          </div>
        </div>
        <>
          <div className='row justify-content-center align-items-center mt-2'>
            {condition.rangeQuery?.conditions?.map((cond) => {
              return (
                <button
                  key={cond._id}
                  className='btn btn-sm btn-primary m-1'
                  title='Click to Remove Condition'
                  onClick={() => {
                    console.log({ cond });
                    dispatch(
                      apiAction({
                        reduxField: 'condition',
                        route: 'conditions/updateRangeQuery',
                        conditionId: condition._id,
                        rangeQuery: {
                          ...condition.rangeQuery,
                          conditions: condition.rangeQuery.conditions.filter((flt) => flt !== cond),
                        },
                      })
                    );
                  }}
                >
                  {cond.conType} {condition.columns.filter((flt) => flt._id === cond.field)[0]?.column_name}{' '}
                  {cond.operation} {cond.value}
                </button>
              );
            })}
          </div>
        </>
        <div className='row justify-content-center align-items-center mt-4'>
          <h4>Limit</h4>
        </div>
        <div className='row justify-content-center align-items-center mt-2'>
          <div className='btn-group'>
            <input
              type='checkbox'
              className='checkbox mr-2'
              checked={condition.rangeQuery?.isLimit}
              onChange={() => {
                dispatch(
                  apiAction({
                    reduxField: 'condition',
                    route: 'conditions/updateRangeQuery',
                    conditionId: condition._id,
                    rangeQuery: {
                      ...condition.rangeQuery,
                      isLimit: !condition.rangeQuery.isLimit,
                    },
                  })
                );
              }}
            />
            <input
              disabled={!condition.rangeQuery?.isLimit}
              type='number'
              className='form-control'
              defaultValue={condition.rangeQuery?.limit}
              style={{ textAlign: 'center' }}
              onBlur={(e) => {
                dispatch(
                  apiAction({
                    reduxField: 'condition',
                    route: 'conditions/updateRangeQuery',
                    conditionId: condition._id,
                    rangeQuery: {
                      ...condition.rangeQuery,
                      limit: parseInt(e.target.value),
                    },
                  })
                );
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectBuilder;
